@if (data(); as msg) {
    <department-item [department]="msg.department" /> not found.
}
 